exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Yantramanav:100);", ""]);

// module
exports.push([module.id, "body{background-color:#eee;font-family:Montserrat,sans-serif;display:grid;grid-template-rows:auto;justify-items:center}body,html{margin:0;height:100%}.About,h1{font-family:Yantramanav,sans-serif;font-size:150%;font-weight:100;color:#f1fff9}.About{margin-top:5%}#app,.column{width:50%}.column{float:left;padding:5px}.row:after{content:\"\";clear:both;display:table}.class{padding-top:500px;margin-bottom:500px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f9aa806","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/About.vue
// module id = 28
// module chunks = 0